module.exports = __webpack_public_path__ + "static/screenshot-81a203769171e739abb946bdd9ef0f68.png";